import React from 'react';
import { ModuleContentTemplate } from './ModuleContentTemplate';
import { module3Config } from '../config/moduleConfigs';

interface User {
  id: string;
  email: string;
  fullName: string;
  company: string;
  role: string;
  status: string;
}

interface Module3ContentProps {
  user: User | null;
  onLogout: () => void;
  isPreviewMode?: boolean;
  invitationEmail?: string;
  isAdminMode?: boolean;
  inviteToken?: string;
}

export function Module3Content({ 
  user, 
  onLogout, 
  isPreviewMode = false, 
  invitationEmail, 
  isAdminMode = false, 
  inviteToken 
}: Module3ContentProps) {
  return (
    <ModuleContentTemplate
      user={user}
      onLogout={onLogout}
      moduleId={3}
      moduleConfig={module3Config}
      isPreviewMode={isPreviewMode}
      invitationEmail={invitationEmail}
      isAdminMode={isAdminMode}
      inviteToken={inviteToken}
    />
  );
}
